module.exports = __webpack_public_path__ + "img/gallery-5.eb73ff22.jpg";